export const projectsData = [
  {
    id: 1,
    type: 'Landing pages',
    technologies: [
      'JavaScript',
      'HTML,CSS,Sass(SCSS)',
      'Figma',
      'Git/GitHub',
      'VS Code',
      'Chrome Developer Tools',
      'BEM',
    ],
    backImage: 'kondo-kings',
    description:
      'Pixel-perfect adaptive landing pages: crisp design, flawless responsiveness, maximum conversion.',
    projects: [
      {
        title: 'Maiami Kondo Kings',
        projectLink: 'https://my-works-showcase.github.io/layout_miami-condo-kings/',
        codeLink:
          'https://github.com/my-works-showcase/layout_miami-condo-kings',
        backImageLink: 'kondo-kings',
      },
    ],
  },
  {
    id: 3,
    type: 'Multi-page website',
    backImage: 'design-studio__image',
    description: 'A responsive multi-page website for an interior design studio',
    technologies: [
      'JavaScript',
      'HTML,CSS,Sass(SCSS)',
      'React',
      'Fetch, Axios, REST API',
      'Figma',
      'Git/GitHub, Chrome Developer Tools',
      'BEM',
    ],
    projects: [
      {
        title: 'Design studio',
        projectLink: 'https://my-works-showcase.github.io/interior-design-studio/',
        codeLink: 'https://github.com/my-works-showcase/interior-design-studio',
        backImageLink: 'design-studio__image',
      },
    ],
  },
  {
    id: 2,
    type: 'Task manager',
    backImage: 'tsk-manager__image',
    description:
      'An interactive to-do created using functional components, hooks, fetch, routing, and local storage.',
    technologies: [
      'JavaScript,TypeScript',
      'HTML,CSS,Sass(SCSS)',
      'React',
      'Fetch, Axios, REST API',
      'Figma',
      'Git/GitHub, Chrome Developer Tools',
    ],
    projects: [
      {
        title: 'Todo App',
        projectLink: 'https://my-works-showcase.github.io/react-todo-app/',
        codeLink: 'https://github.com/my-works-showcase/react-todo-app',
        backImageLink: 'tsk-manager__image',
      },
    ],
  },
  {
    id: 4,
    type: 'Puzzle game',
    backImage: 'game__image',
    description: 'The game is written in pure Java Script.',
    technologies: [
      'JavaScript',
      'HTML,CSS,Sass(SCSS)',
      'Figma',
      'Git/GitHub',
      'VS Code',
      'Chrome Developer Tools',
      'BEM',
    ],
    projects: [
      {
        title: 'Sum matrix',
        projectLink: 'https://my-works-showcase.github.io/game_summatrix/',
        codeLink:
          'https://github.com/my-works-showcase/game_summatrix',
        backImageLink: 'game__image',
      },
    ],
  },
];
